import { LOCAL_STORAGE_NAMES } from '../constants/constants';

const parseStoredJson = (key: string): unknown => {
  try {
    return JSON.parse(localStorage.getItem(key) ?? 'null');
  } catch {
    return null;
  }
};

const readPreferencesByUser = (storageKey: string): Record<string, unknown> => {
  const stored = parseStoredJson(storageKey);
  return stored && typeof stored === 'object' ? (stored as Record<string, unknown>) : {};
};

export const readStoredUserId = (): string | undefined => {
  const user = parseStoredJson(LOCAL_STORAGE_NAMES.user) as { id?: unknown } | null;
  return typeof user?.id === 'string' ? user.id : undefined;
};

export const readUserPreference = <T>(
  storageKey: string,
  userId: string | undefined,
  isValid: (value: unknown) => value is T,
  fallback: T,
): T => {
  if (!userId) return fallback;
  const stored = readPreferencesByUser(storageKey)[userId];
  return isValid(stored) ? stored : fallback;
};

export const hasUserPreference = (storageKey: string, userId: string | undefined): boolean => {
  if (!userId) return false;
  return readPreferencesByUser(storageKey)[userId] !== undefined;
};

export const storeUserPreference = (
  storageKey: string,
  userId: string,
  value: string | number,
): void => {
  const preferencesByUser = { ...readPreferencesByUser(storageKey), [userId]: value };
  localStorage.setItem(storageKey, JSON.stringify(preferencesByUser));
};
